import React, { FC, ReactElement, RefObject, useContext } from 'react'
import { DatePicker, MuiPickersUtilsProvider } from 'akixi-material-ui-pickers'
import MomentUtils from '@date-io/moment'
import Label from '../Label'
import {
    Controller,
    ControllerRenderProps,
    useFormContext,
    UseFormMethods
} from '../../../../Vendor/react-hook-form/dist/index.ie11'
import { UserInfoContextType } from '../../Contexts/UserInfoContext'
import { UserInfoContext } from '../../Contexts'
import { Rules } from '../../Types/Types'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'

type Props = {
    name: string
    label?: string
    rules?: Rules
    placeholder?: string
    clearable?: boolean
    inputRef?: RefObject<HTMLElement>
    onEnter?: (event: React.KeyboardEvent) => void
    disablePast?: boolean
}

export const DatePickerForms: FC<Props> = ({
    name,
    label,
    rules,
    placeholder,
    clearable,
    inputRef,
    onEnter,
    disablePast
}: Props): ReactElement => {
    const { control, watch }: UseFormMethods = useFormContext()

    const userInfo: UserInfoContextType = useContext(UserInfoContext)

    return (
        <MuiPickersUtilsProvider utils={MomentUtils} locale={userInfo?.SessionInfo?.Language}>
            <div className='picker-wrapper'>
                {label && <Label customClass='label-left'>{label}</Label>}
                <div className='picker'>
                    <Controller
                        control={control}
                        name={name}
                        defaultValue={watch(name, EMPTY_STRING)}
                        rules={rules}
                        render={({
                            onChange: onChangeForm,
                            onBlur: onBlurForm,
                            value: valueForm,
                            name: nameForm,
                            ref
                        }: ControllerRenderProps<Record<string, unknown>>): ReactElement => (
                            <DatePicker
                                name={nameForm}
                                ref={inputRef as RefObject<HTMLInputElement>}
                                inputRef={ref}
                                placeholder={placeholder}
                                orientation='portrait'
                                format='DD/MM/YYYY'
                                disablePast={disablePast}
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                value={valueForm}
                                onBlur={onBlurForm}
                                onChange={onChangeForm}
                                onKeyDown={(event: React.KeyboardEvent): void => {
                                    if (event.key === 'Enter' && onEnter) {
                                        onEnter(event)
                                    }
                                }}
                                clearable={clearable}
                            />
                        )}
                    />
                </div>
            </div>
        </MuiPickersUtilsProvider>
    )
}
